<!-- <div *ngFor="let modulePackage of modulePackages">
    <app-module-package [modulePackage]="modulePackage"></app-module-package>
</div>> -->

  <ul *ngIf="modulePackages && modulePackages.length > 0" class="progress-cards-wrap">
    <li *ngFor="let modulePackage of modulePackages">
        <app-module-package [modulePackage]="modulePackage"></app-module-package>
    </li>
  </ul>